<!-- For web Screens  -->

<app-loading *ngIf="(isLoading$ | async)" title="step groups"></app-loading>
<div #screenSize>

    <ng-container *ngIf="!isMobile">
        <ng-container *ngIf="!planHasDevices.length && !devicesLIst?.length && !(isLoading$ | async)">
            <div *ngIf="!planHasDevices.length" class="main-wrapper-container" id="main-wrapper-container-responsive">
                <app-left-storage-nav *ngIf="!newPlanDevicesForMobile || !planHasDevices?.length " (planDevicesChange)="handlePlanDevicesChange($event)"
                                      [shopCampatibleDevices]="shopCampatibleDevices"></app-left-storage-nav>
                <div *ngIf="!(isLoading$ | async) && shopCampatibleDevices && !planDevices && !devicesLIst?.length" class="home-page-wrapper">
                    <ng-container *ngIf="!(isLoading$ | async) && shopCampatibleDevices && !planDevices && !devicesLIst?.length">
                        <div class="image-container">
                            <img src="assets/images/Image-10.png" alt="placeholder-image">
                        </div>
                        <div class="home-page-content">
                            <h2 i18n="@@noDevices">No Compatible Devices Found</h2>
                            <p i18n="@@noCompatibleDevices">You currently do not have any devices that are compatible
                                with Lorex Cloud Storage.
                                If you have a compatible camera, please ensure that it has been set up and added to this
                                account,
                                or visit our web store to shop for compatible devices.</p>
                            <div class="home-page-btn">
                                <button class="btn " i18n="@@shopCompatible" (click)="goToShop()">Shop compatible
                                    devices
                                </button>
                                <button class="btn" i18n="@@downloadApp" (click)="goToApp()">Download the Lorex
                                    App
                                </button>

                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!shopCampatibleDevices || planDevices ">
                        <!-- <app-loading *ngIf="(isLoading$ | async)" title="step groups"></app-loading> -->

                        <app-devices [shopCampatible]="shopCampatibleDevices" [existingPlanToNew]="true" [createCheck]="true"></app-devices>
                    </ng-container>
                </div>
            </div>
        </ng-container>


        <ng-container *ngIf="!planHasDevices.length && devicesLIst?.length && !(isLoading$ | async)">
            <div *ngIf="!planHasDevices.length" class="main-wrapper-container">
                <app-left-storage-nav *ngIf="!newPlanDevicesForMobile || !planHasDevices?.length" (planDevicesChange)="handlePlanDevicesChange($event)"
                                      [shopCampatibleDevices]="shopCampatibleDevices"></app-left-storage-nav>
                <div class="home-page-wrapper">

                    <ng-container *ngIf="devicesLIst?.length">

                        <app-devices [shopCampatible]="shopCampatibleDevices" [devicesLIstHome]="devicesLIst" [existingPlanToNew]="true" [createCheck]="true"></app-devices>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <!-- plan Have but no devices -->

        <ng-container *ngIf="planHasDevices.length > 0 && checkPlanHaveNoDevices && !(isLoading$ | async)">
            <app-left-storage-nav *ngIf="planHasDevices.length" (switchExistingToNew)="handleSwitch($event)"
                                  [shopCampatibleDevices]="!shopCampatibleDevices"
                                  [existingPlanToNew]="existingPlanToNew" [checkPlanHaveNoDevices]="checkPlanHaveNoDevices" [subscriptions]="planHasDevices"></app-left-storage-nav>
        </ng-container>
    </ng-container>


    <!-- For Mobile Screens  -->

    <ng-container *ngIf="isMobile">
        <ng-container *ngIf="!planHasDevices?.length && devicesLIst?.length === 0 && !(isLoading$ | async)">
            <div class="main-wrapper-container" id="main-wrapper-container-mobile">
                one
                <app-left-storage-nav *ngIf="!newPlanDevicesForMobile && !planHasDevices?.length" (planDevicesChange)="handlePlanDevicesChange($event)" (addNewPlanButtonClicked)="addNewPlanButtonClicked()"
                                      [shopCampatibleDevices]="shopCampatibleDevices" [existingPlanToNew]="true"></app-left-storage-nav>
                <div class="home-page-wrapper" *ngIf="showDevices">
                    <ng-container *ngIf="!(isLoading$ | async) && shopCampatibleDevices && !planDevices">
                        <div class="image-container">
                            <img src="assets/images/Image-10.png" alt="placeholder-image">
                        </div>
                        <div class="home-page-content">
                            <h2 i18n="@@noDevices">No Compatible Devices Found</h2>
                            <p i18n="@@noCompatibleDevices">You currently do not have any devices that are compatible
                                with Lorex Cloud Storage.
                                If you have a compatible camera, please ensure that it has been set up and added to this
                                account,
                                or visit our web store to shop for compatible devices.</p>
                            <div class="home-page-btn">
                                <button class="btn " i18n="@@shopCompatible" (click)="goToShop()">Shop compatible
                                    devices
                                </button>
                                <button class="btn" i18n="@@downloadApp" (click)="goToApp()">Download the Lorex
                                    App
                                </button>

                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!shopCampatibleDevices && planDevices || newPlanDevicesForMobile ">
                        <app-devices [shopCampatible]="shopCampatibleDevices" [existingPlanToNew]="true"></app-devices>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- *ngIf="!planHasDevices.length && devicesLIst?.length && !(isLoading$ | async)" -->
        <ng-container *ngIf="!planHasDevices.length && devicesLIst?.length && !(isLoading$ | async)">
            <div *ngIf="!planHasDevices.length" class="main-wrapper-container">
                <app-left-storage-nav *ngIf="(!newPlanDevicesForMobile || !planHasDevices?.length) && showMenu" (planDevicesChange)="handlePlanDevicesChange($event)" (addNewPlanButtonClicked)="addNewPlanButtonClicked()"
                                      [shopCampatibleDevices]="shopCampatibleDevices"></app-left-storage-nav>
                <!-- Show this if the add new plan button is clicked -->
                <div class="home-page-wrapper" *ngIf="showDevices">

                    <ng-container *ngIf="devicesLIst?.length">
                        <app-devices [shopCampatible]="shopCampatibleDevices" [devicesLIstHome]="devicesLIst" [existingPlanToNew]="true" [createCheck]="true"></app-devices>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- *ngIf="planHasDevices.length > 0 && checkPlanHaveNoDevices" -->
        <ng-container *ngIf="planHasDevices.length > 0 && checkPlanHaveNoDevices">
            <app-left-storage-nav *ngIf="planHasDevices.length" (switchExistingToNew)="handleSwitch($event)"
                                  [shopCampatibleDevices]="!shopCampatibleDevices"
                                  [existingPlanToNew]="existingPlanToNew" [checkPlanHaveNoDevices]="checkPlanHaveNoDevices" [subscriptions]="planHasDevices"></app-left-storage-nav>
        </ng-container>

    </ng-container>
</div>